import { createFileRoute } from '@tanstack/react-router'

import { SimpleMessageScreen } from '@/components/system-screens'

const InternetExplorerPage = () => (
  <SimpleMessageScreen title="Internet Explorer には対応していません">
    Google Chromeなど、他のブラウザをご利用ください。
  </SimpleMessageScreen>
)

export const Route = createFileRoute('/ie')({ component: InternetExplorerPage })
